import type { ValueGetterParams } from 'ag-grid-community';
import type { OrganizationUserType, UserWithOrganizationType } from '../../types/user';

/**
 * ユーザが所属する組織を調べてユーザの所属組織一覧を返す
 * @param [ValueGetterParams]
 * @returns [string] - ユーザ所属組織の配列をカンマ連結した文字列
 */
const organizationUserValueGetter = (params: ValueGetterParams): string => {
  const data: UserWithOrganizationType = params.data;
  const organizations: OrganizationUserType[] | undefined = data.organizations;
  // console.log(params.data);
  const organizationNames: string = organizations.map((company) => company.organizationBaseName + ' ' + company.organizationSuffixName).join(', ');
  return organizationNames;
};

export default organizationUserValueGetter;
